export default "__VITE_ASSET__BsjMZBwk__"